import { WORKSPACE_AGENT_PANEL_ELEMENT_ID } from '~/components/v2/components/workspace/workspace-agent-panel/workspaceAgentPanelConstants';

/** True when the key landed inside the docked agent panel, not a sibling surface like the asset modal. */
export const isWorkspaceAgentPanelHotkeyEvent = (event: KeyboardEvent): boolean => {
  const { target } = event;

  if (!(target instanceof Node)) {
    return false;
  }

  const panel = document.getElementById(WORKSPACE_AGENT_PANEL_ELEMENT_ID);

  return panel?.contains(target) === true;
};
